import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OneTrustService {
  private readonly _renderer2: Renderer2;

  constructor(
    @Inject(DOCUMENT)
    private readonly _document: Document,
    private readonly _rendererFactory: RendererFactory2,
  ) {
    this._renderer2 = this._rendererFactory.createRenderer(null, null);
  }

  public addScriptToDom(): Promise<unknown> {
    // if (environment.development) {
    //   return new Promise((resolve) => resolve(true));
    // }
    return new Promise((resolve, reject) => {
      if (
        environment.oneScriptDataDomainKey &&
        !this._document.getElementById('loreal-events-one-trust-second-script')
      ) {
        const secondScript = this._renderer2.createElement('script');
        secondScript.id = 'loreal-events-one-trust-first-script';
        secondScript.charset = 'UTF-8';
        secondScript.type = 'text/javascript';
        secondScript.innerHTML = `
        function OptanonWrapper() { }
      `;
        this._document.head.insertBefore(secondScript, this._document.head.firstChild);

        const firstScript = this._renderer2.createElement('script');
        firstScript.src = `https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`;
        this._renderer2.setAttribute(firstScript, 'data-document-language', 'true');
        firstScript.type = 'text/javascript';
        firstScript.charset = 'UTF-8';
        this._renderer2.setAttribute(firstScript, 'data-domain-script', environment.oneScriptDataDomainKey);
        firstScript.defer = true;
        firstScript.async = true;
        firstScript.onload = resolve;
        firstScript.onerror = reject;
        firstScript.id = 'loreal-events-one-trust-second-script';
        // this._renderer2.setAttribute(firstScript, 'data-language', language);
        this._document.head.insertBefore(firstScript, this._document.head.firstChild);
      }
      return null;
    });
  }
}
